import React from "react";
import { twMerge } from "tailwind-merge";

type CharacterCounterProps = {
  currentLength: number;
  maxLength: number;
  warningThreshold?: number;
  className?: string;
};

export const CharacterCounter: React.FC<CharacterCounterProps> = ({
  currentLength,
  maxLength,
  warningThreshold = 0.9,
  className = "",
}) => {
  const isAtOrOverLimit = currentLength >= maxLength;
  const isNearLimit = currentLength > maxLength * warningThreshold;

  const getColorClass = () => {
    if (isAtOrOverLimit) {
      return "text-red-600 font-medium";
    }
    if (isNearLimit) {
      return "text-amber-600 font-medium";
    }
    return "text-gray-500";
  };

  return (
    <div className={twMerge("w-full text-right", className)}>
      <span className={`text-xs ${getColorClass()}`}>
        {currentLength}/{maxLength}
      </span>
    </div>
  );
};
